module.exports = __webpack_public_path__ + "static/img/global_message@3x.19ae2c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_message@3x.png
// module id = PV2m
// module chunks = 1